import { useQuery } from '@tanstack/react-query';
import type { ReconcileStatus } from '@repo/shared-types';
import { fetchApi } from '../lib/api';

// Org's auto-reconcile (SePay) status + monthly usage meter. Shared by the
// bank settings tab (status + meter + nudge) and the chốt-tháng flow (soft
// warning when the invoice run is about to exceed the remaining quota).
//
// `enabled` defaults to true (same shape as usePaymentsSummary) so existing
// callers on pages gated at the route level are unaffected; a caller whose
// own UI is conditionally rendered for a role (e.g. useAttentionItems, or a
// sidebar shown only to some roles) must pass its own gate through so the
// hook is never fetched for a role whose UI never renders it (THI-136).
export function useReconcileStatus(enabled = true) {
  return useQuery<ReconcileStatus>({
    queryKey: ['bank-accounts', 'reconcile-status'],
    queryFn: () => fetchApi<ReconcileStatus>('/bank-accounts/reconcile-status'),
    enabled,
  });
}
